"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Context = require("../Context");
var _Portal = _interopRequireDefault(require("../../../components/Portal"));
var _Dropdown = _interopRequireDefault(require("../../../components/Icons/Dropdown"));
var _ChevronUp = _interopRequireDefault(require("../../../components/Icons/ChevronUp"));
var _menu = require("../../utils/menu");
var Styled = _interopRequireWildcard(require("./styles/mds"));
var _utils = require("./utils");
var _HeaderMenuItem = _interopRequireDefault(require("./HeaderMenuItem"));
var _sanitizer = require("../../utils/sanitizer");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const MDSSolutionSwitcher = _react.default.memo(({
  headerBasedSitemap,
  header,
  menu,
  showBurgerMenu,
  solutions = [],
  activeSolution = {},
  history
}) => {
  const switcherNode = (0, _react.useRef)(null);
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const [position, setPosition] = (0, _react.useState)({});
  const config = (0, _react.useContext)(_Context.ConfigContext);
  (0, _react.useLayoutEffect)(() => {
    const pos = (0, _utils.getPosition)(switcherNode.current);
    setPosition(pos);
  }, [isOpen]);
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const closeDropdown = (0, _react.useCallback)(event => {
    event.stopPropagation();
    setIsOpen(false);
  }, []);
  const withinSameModule = link => (0, _menu.isWithinSameModule)(link, config.appPrefix) && history;
  const handleNavigate = link => () => {
    const nextPath = (0, _menu.getPathFromLink)(link, config.appPrefix);
    history.push(nextPath);
    setIsOpen(false);
  };
  const isExpandedMenuHidden = headerBasedSitemap ? showBurgerMenu : header && menu && showBurgerMenu;
  const isCollapsedMenuVisible = header && menu && !headerBasedSitemap && showBurgerMenu;
  const renderCollapsedMenu = items => _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(Styled.SwitcherHeader, {
    isOpen: isOpen,
    onClick: toggleDropdown
  }, _react.default.createElement(Styled.SwitcherHeaderTitle, {
    title: activeSolution.label
  }, activeSolution.label), _react.default.createElement(Styled.SwitcherIconContainer, null, isOpen ? _react.default.createElement(_ChevronUp.default, null) : _react.default.createElement(_Dropdown.default, null))), isOpen && _react.default.createElement(_Portal.default, null, _react.default.createElement(Styled.ClickOutside, {
    onClickOutside: closeDropdown
  }, _react.default.createElement(Styled.DropdownContainer, {
    style: {
      top: position.bottom,
      left: position.left
    }
  }, _react.default.createElement(Styled.DropdownInner, null, items.map((item, idx) => {
    const sanitizedUri = (0, _sanitizer.sanitizeHref)(item.uri);
    return _react.default.createElement(Styled.DropdownItem, {
      key: idx
    }, _react.default.createElement(Styled.DropdownItemLabel, {
      title: item.label,
      href: withinSameModule(sanitizedUri) ? null : sanitizedUri,
      onClick: withinSameModule(sanitizedUri) ? handleNavigate(sanitizedUri) : null
    }, item.label));
  }))))));
  const renderExpandedMenu = items => _react.default.createElement(Styled.ExpandedMenu, {
    $hidden: isExpandedMenuHidden
  }, items.map(item => {
    const sanitizedUri = (0, _sanitizer.sanitizeHref)(item.uri);
    return _react.default.createElement(_HeaderMenuItem.default, {
      key: item.id,
      item: item,
      isActive: item.id === activeSolution.id,
      history: history,
      href: withinSameModule(sanitizedUri) ? null : sanitizedUri,
      onClick: withinSameModule(sanitizedUri) ? handleNavigate(sanitizedUri) : null
    });
  }));
  return _react.default.createElement(Styled.Switcher, {
    ref: switcherNode,
    expanded: headerBasedSitemap,
    isExpandedMenuHidden: isExpandedMenuHidden
  }, isCollapsedMenuVisible && renderCollapsedMenu(solutions), renderExpandedMenu(solutions));
});
var _default = exports.default = MDSSolutionSwitcher;